<!-- eslint-disable max-len -->
<template>
<svg width="11" height="15" viewBox="0 0 11.896 16.226" fill="none">
    <path
        d="M4.74063 1.24265C5.41476 0.655512 6.41799 0.65229 7.09609
            1.23484L10.4691 4.1323C10.8672 4.47425 11.0961 4.97375 11.0961
            5.49851V13.6255C11.0961 14.6196 10.2904 15.4262 9.29629
            15.4262H2.6C1.60589 15.4262 0.800195 14.6196 0.800195
            13.6255L0.800195 5.49363C0.800302 4.97328 1.02499 4.47797
            1.41738 4.1362L4.74063 1.24265Z"
        stroke="currentColor" stroke-width="1.6"
    />
    <path
        d="M5.96093 4.22369C6.71288 4.22369 7.33292 4.82733 7.333
            5.58502C7.333 6.34277 6.71293 6.94634 5.96093 6.94634C5.20901
            6.94626 4.58886 6.34271 4.58886 5.58502C4.58894 4.82739 5.20906
            4.22377 5.96093 4.22369Z"
        stroke="currentColor" stroke-width="0.8"
    />
</svg>
</template>
